(() => {
  if (window.freejoyNavigationReady) return;
  window.freejoyNavigationReady = true;
  const closeBranch = (branch, focus = false) => {
    branch.open = false;
    if (focus) branch.querySelector(':scope > summary')?.focus();
  };
  const initialise = (root = document) => {
    root.querySelectorAll('[data-fj-primary-list],[data-fj-native-list]').forEach((list) => {
      if (list.dataset.navigationReady) return;
      list.dataset.navigationReady = 'true';
      list.querySelectorAll('.fj-primary-branch').forEach((branch) => {
        branch.addEventListener('toggle', () => {
          if (!branch.open) return;
          list.querySelectorAll('.fj-primary-branch[open]').forEach((other) => {
            if (other !== branch) closeBranch(other);
          });
        });
      });
      const current = new URL(location.href);
      const filterKeys = ['inseam','size','color','fit','sort','in_stock'];
      list.querySelectorAll('[data-fj-nav-link]').forEach((link) => {
        const target = new URL(link.href, location.href);
        let matches = target.origin === current.origin && target.pathname === current.pathname;
        const targetHasFilter = filterKeys.some((key) => target.searchParams.has(key));
        const currentHasFilter = filterKeys.some((key) => current.searchParams.has(key));
        if (matches && targetHasFilter) matches = filterKeys.every((key) => !target.searchParams.has(key) || target.searchParams.get(key) === current.searchParams.get(key));
        if (matches && !targetHasFilter && currentHasFilter && link.closest('.fj-primary-submenu,.mega-menu__list')) matches = false;
        if (matches && target.hash) matches = target.hash === current.hash;
        link.toggleAttribute('aria-current', matches);
        if (matches) link.setAttribute('aria-current','page');
      });
    });
  };
  document.addEventListener('keydown', (event) => {
    if (!(event.target instanceof Element)) return;
    if (event.key !== 'Escape') return;
    const branch = event.target.closest('.fj-primary-branch[open]') || event.target.closest('.fj-primary-item')?.querySelector(':scope > .fj-primary-branch[open]');
    if (branch) {
      closeBranch(branch, true);
      event.stopImmediatePropagation();
      event.preventDefault();
      return;
    }
    const mobile = event.target.closest('[data-fj-mobile-nav][open]');
    if (mobile) closeBranch(mobile, true);
  }, true);
  document.addEventListener('pointerdown', (event) => {
    if (!(event.target instanceof Element)) return;
    document.querySelectorAll('.fj-primary-list--desktop .fj-primary-branch[open]').forEach((branch) => {
      if (!branch.parentElement.contains(event.target)) closeBranch(branch);
    });
    document.querySelectorAll('[data-fj-mobile-nav][open]').forEach((menu) => {
      if (!menu.contains(event.target)) closeBranch(menu);
    });
  }, true);
  document.addEventListener('focusin', (event) => {
    document.querySelectorAll('.fj-primary-list--desktop .fj-primary-branch[open]').forEach((branch) => {
      if (!branch.parentElement.contains(event.target)) closeBranch(branch);
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise());
  else initialise();
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();

document.addEventListener('click',event=>{const close=event.target.closest('[data-fj-menu-close]');if(close){const menu=close.closest('details');menu.open=false;menu.querySelector('summary').focus();}});
